export default "__VITE_ASSET__Bmc$taKv__"